<template>
  <!-- footer area start -->
  <footer id="apork-footer-area" class="apork-footer-area pt-100">
    <div class="container">
      <div class="row">
        <div class="col-xl-3 col-lg-4 col-md-4 col-sm-12">
          <div class="footer-widget widget-1">
            <div class="footer-logo">
              <a href="#" class="brand-logo brand-logo--light">
                <img src="../assets/picture/sicunxindong-icon.png" alt="" class="brand-logo__icon" />
                <span class="brand-logo__name">私存心动</span>
              </a>
            </div>

            <p>
              在这里有悲伤 有喜悦 有回忆
              也有新的故事，在这里你可以尽情的聊天交友
              畅聊世界，这里就是有你有我的私存心动。
            </p>
          </div>
        </div>
        <div class="col-xl-3 offset-xl-1 col-lg-3 col-md-4 col-sm-12">
          <div class="footer-widget widget-1">
            <h3>私存心动资讯</h3>
            <p>
              私存心动是一款主打语音房间交流形态的社区交友平台，拥有创新的社交模式。语音房间涵盖内容广泛，涉及到生活的方方面面，从文化到旅游，从交友到创业，年轻人们可以根据自己的实际情况选择适合自己的语音交流空间，找到一群和自己志同道合的好友，进行有益的社交行为。
            </p>
          </div>
        </div>
        <div class="col-xl-4 offset-xl-1 col-lg-5 col-md-4 col-sm-12">
          <div class="footer-widget widget-2">
            <h3>照片墙</h3>
            <ul class="gallery-all-img">
              <li>
                <a href="#"
                  ><img src="../assets/picture/gallery-1.jpg" alt="wdg-img"
                /></a>
              </li>
              <li>
                <a href="#"
                  ><img src="../assets/picture/gallery-2.jpg" alt="wdg-img"
                /></a>
              </li>
              <li>
                <a href="#"
                  ><img src="../assets/picture/gallery-3.jpg" alt="wdg-img"
                /></a>
              </li>
              <li>
                <a href="#"
                  ><img src="../assets/picture/gallery-4.jpg" alt="wdg-img"
                /></a>
              </li>
              <li>
                <a href="#"
                  ><img src="../assets/picture/gallery-5.jpg" alt="wdg-img"
                /></a>
              </li>
              <li>
                <a href="#"
                  ><img src="../assets/picture/gallery-6.jpg" alt="wdg-img"
                /></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-12 col-lg-12">
          <div class="footer-copyright text-center pt-40 pb-40">
            <p>
              <a>违法和不良信息举报电话：4006690888&nbsp;&nbsp;</a
              ><a>消费者维权/客户服务/青少年守护专线：4006690888</a>
            </p>

            <p>
              <span>@2026私存心动 </span>
              <a
                href="http://beian.miit.gov.cn"
                rel="external nofollow"
                target="_blank"
                >深圳云逢科技有限公司 粤ICP备2026092458号
              </a>
              <a>
                深圳市福田区沙头街道天安社区泰然四路113号泰然科技园213栋四层4D128E
              </a>
            </p>
            <p>
              <a rel="external nofollow">
                营业执照：91440300MAKDQU1Q8W</a>
              <a rel="external nofollow">
                域名证书：xinyucp.com</a>
            </p>
            <p>
              <a
                href="https://xinyucp.com/home/protocol/user_protocol"
                tag="a"
                target="_blank"
                >用户协议</a>
              &nbsp;&nbsp;
              <a
                href="https://xinyucp.com/home/protocol/privacy_protocol"
                tag="a"
                target="_blank"
                >隐私协议</a>
                &nbsp;&nbsp;
              <a href="javascript:void(0);"> 版本信息：1.0.0</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Foot",
};
</script>

<style lang="less" scoped>
</style>
